import { Switch } from '@mui/material';

export type SwitchControlProps = {
  checked: boolean;
  isDisable: boolean;
  setChecked?: any;
  onClick?: any;
};

const SwitchControl = ({
  checked,
  isDisable,
  setChecked,
  onClick,
}: SwitchControlProps) => {
  return (
    <Switch
      checked={checked}
      disabled={isDisable}
      onChange={() => (setChecked ? setChecked(!checked) : null)}
      onClick={() => (onClick ? onClick() : null)}
      sx={{
        width: '34px',
        height: '20px',
        float: 'right',
        padding: 0,
      }}
      data-testid="switch-control"
    />
  );
};
export default SwitchControl;
